import { render, staticRenderFns } from "./ReportImport.vue?vue&type=template&id=3f52481e&scoped=true"
import script from "./ReportImport.vue?vue&type=script&lang=js"
export * from "./ReportImport.vue?vue&type=script&lang=js"
import style0 from "./ReportImport.vue?vue&type=style&index=0&id=3f52481e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f52481e",
  null
  
)

export default component.exports